import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from '../../components/common/Sidebar';
import { Topbar } from '../../components/common/Topbar';
import { NavItem } from '../../constants/nav';
import { AdRenderer } from '../../components/ads/AdRenderer';
import { fetchFeatureAccess } from '../../features/journal/api/journal';

export function DashboardLayout({
  navItems,
  title,
  children,
}: {
  navItems: NavItem[];
  title: string;
  children: React.ReactNode;
}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [access, setAccess] = useState<Record<string, boolean> | null>(null);
  const location = useLocation();

  const hasFeatureItems = navItems.some((i) => i.feature);

  React.useEffect(() => {
    if (!hasFeatureItems) return;
    fetchFeatureAccess().then((a) => setAccess(a as any)).catch(() => setAccess({}));
  }, [hasFeatureItems]);

  // Close the mobile drawer whenever the route changes.
  React.useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const items = navItems.filter((i) => {
    if (!i.feature) return true;
    if (access == null) return false; // hide gated items until access is resolved
    return !!access[i.feature];
  });

  return (
    <div className="min-h-screen bg-[#050914] text-white selection:bg-cyan-400/30">
      <AdRenderer />
      <Sidebar items={items} open={mobileOpen} onClose={() => setMobileOpen(false)} />
      {mobileOpen && (
        <div
          data-testid="sidebar-overlay"
          onClick={() => setMobileOpen(false)}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
        />
      )}
      <Topbar title={title} onMenu={() => setMobileOpen(true)} />
      <main className="pt-24 pb-12 px-4 sm:px-6 lg:pl-72 lg:pr-8 min-h-screen animate-in fade-in slide-in-from-bottom-4 duration-500">
        {children}
      </main>
    </div>
  );
}
